import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.*
import di.commonModule
import di.uiModule
import org.jetbrains.skiko.wasm.onWasmReady
import org.koin.core.context.startKoin

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    startKoin {
        modules(commonModule + uiModule)
    }

    onWasmReady {
        CanvasBasedWindow(
            title = "Odia App",
        ) {
            App()
        }
    }
}